export const DISCLAIMER_FULL =
  "SmartEssay.ai is an AI writing assistant designed to help brainstorm, outline, research real quotes & citations, structure ideas, paraphrase, and polish writing. Users are 100% responsible for the final content they submit. Word-for-word submission of AI-generated material without substantial original contribution, editing, and proper disclosure may constitute academic misconduct at most schools and universities. Always review, rewrite in your own words, verify all sources, and follow your institution's policies.";

export const DISCLAIMER_SHORT =
  "I understand SmartEssay.ai is an assistive tool only. I take full responsibility for academic compliance and will edit/own the final work.";

export const DISCLAIMER_LEGAL =
  "SmartEssay.ai provides assistive technology only. We do not authorize or encourage representing AI-generated content as entirely your own work without meaningful revision and disclosure. You retain full responsibility and liability for any submitted work.";

export function disclaimerPdfFooter(date: Date = new Date()): string {
  const formatted = date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  return `Assisted by SmartEssay.ai  •  User is solely responsible for academic integrity  •  Edit substantially before submission  •  Generated ${formatted}`;
}

export const CONSENT_STORAGE_KEY = "smartessay.ack.v1";

export function disclaimerTextCopy(): string {
  return "\n\n---\nACADEMIC INTEGRITY NOTICE\nThis content was generated by SmartEssay.ai as an assistive tool. You are solely responsible for reviewing, rewriting in your own words, verifying all sources, and following your institution's academic integrity policies before submission.\n---\n";
}

